import { render, staticRenderFns } from "./CompTable.vue?vue&type=template&id=6c23ca1a&scoped=true"
import script from "./CompTable.vue?vue&type=script&lang=js"
export * from "./CompTable.vue?vue&type=script&lang=js"
import style0 from "./CompTable.vue?vue&type=style&index=0&id=6c23ca1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23ca1a",
  null
  
)

export default component.exports